import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';
import { MfeAppConfig } from '../app.environment';
import { RouteService } from './route/route.service';
import { EnvironmentService } from './environment/environment.service';

/**
 * This UrlSerializer implementation is needed to support the requirement for having a root MFE in the root path.
 * See the router service for more information.
 */
@Injectable({
  providedIn: 'root'
})
export class UrlSerializerService extends UrlSerializer {
  private readonly defaultSerializer = new DefaultUrlSerializer();

  private rootMFE: MfeAppConfig | undefined;

  constructor(
    private environmentService: EnvironmentService,
    private readonly routeService: RouteService
  ) {
    super();

    this.rootMFE = this.routeService.getRootMFE();
  }

  override parse(url: string): UrlTree {
    return this.defaultSerializer.parse(url);
  }

  /**
   * If useRootPath is true, this serializer will remove the root MFE's prefix in the output URL which will give the illusion that the root MFE is being loaded into the rooth path.
   * Behind the scenes, the root MFE is still loaded under its route prefix.
   */
  override serialize(tree: UrlTree): string {
    const base = this.defaultSerializer.serialize(tree);
    if (!this.environmentService.get('useRootPath') || !this.rootMFE) {
      return base;
    }

    return base.replace('/' + this.rootMFE.path, '');
  }
}
